import { render } from "./ItemAddonSingle.vue?vue&type=template&id=3408219f&scoped=true&ts=true"
import script from "./ItemAddonSingle.vue?vue&type=script&lang=ts"
export * from "./ItemAddonSingle.vue?vue&type=script&lang=ts"

import "./ItemAddonSingle.vue?vue&type=style&index=0&id=3408219f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3408219f"]])

export default __exports__